import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import Report from '../../../../common/components/Report';
import {
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/ReceptacleOverviewSelectors';

// Email-only report: the async path never renders a results table, so no columns are defined.
const NO_COLUMNS = [];

export function ReceptacleOverviewContainer(props) {
  return (
    <Report
      reportId={ReportDefinitions.RECEPTACLE_OVERVIEW.id}
      columns={NO_COLUMNS}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
  };
}

ReceptacleOverviewContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default connect(mapStateToProps)(ReceptacleOverviewContainer);
